export const matchUrl = (match) =>
  `/match/${match.teams.map((t) => t.code).join('-vs-')}-${match.id}`

export const matchLabel = (league, match) =>
  `${league.name} - ${match.teams.map((t) => t.code).join(' vs ')}`
